import React, { useState } from 'react';
import { generateMonthlyTimesheets } from '../services/monthlyTimesheetGenerator';
import './GenerateMonthlyButton.css';

const GenerateMonthlyButton = ({ onSuccess }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [result, setResult] = useState(null);

  // Calculer le mois précédent
  const now = new Date();
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  const lastMonthName = monthNames[lastMonth.getMonth()];
  const lastMonthYear = lastMonth.getFullYear();
  const buttonText = `📅 Générer feuilles de ${lastMonthName} ${lastMonthYear}`;

  const handleGenerate = async () => {
    if (!window.confirm(`Générer les feuilles de temps de ${lastMonthName} ${lastMonthYear} pour tous les employés ?`)) {
      return;
    }

    setIsGenerating(true);
    setShowModal(true);

    try {
      const res = await generateMonthlyTimesheets();
      setResult(res);
      
      if (res.success && onSuccess) {
        onSuccess();
      }
    } catch (error) {
      setResult({
        success: false,
        error: error.message
      });
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <button 
        className="generate-monthly-btn"
        onClick={handleGenerate}
        disabled={isGenerating}
      >
        {isGenerating ? '⏳ Génération en cours...' : buttonText}
      </button>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>📊 Résultat de la génération</h3>
            
            {isGenerating && (
              <div className="loading">
                <div className="spinner"></div>
                <p>Génération des feuilles en cours...</p>
              </div>
            )}

            {result && !isGenerating && (
              <div className="result">
                {result.success ? (
                  <>
                    <div className="success-header">
                      <span className="icon">✅</span>
                      <h4>Feuilles générées pour {result.monthName} {result.year}</h4>
                    </div>

                    <div className="stats">
                      <div className="stat success">
                        <span className="number">{result.results.success.length}</span>
                        <span className="label">Créée(s)</span>
                      </div>
                      <div className="stat skipped">
                        <span className="number">{result.results.skipped.length}</span>
                        <span className="label">Ignorée(s)</span>
                      </div>
                      <div className="stat error">
                        <span className="number">{result.results.errors.length}</span>
                        <span className="label">Erreur(s)</span>
                      </div>
                    </div>

                    {result.results.success.length > 0 && (
                      <div className="details">
                        <h5>✅ Feuilles créées :</h5>
                        <ul>
                          {result.results.success.map((item, idx) => (
                            <li key={idx}>
                              {item.email} - {item.hours}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {result.results.skipped.length > 0 && (
                      <div className="details">
                        <h5>⚠️ Feuilles déjà existantes :</h5>
                        <ul>
                          {result.results.skipped.map((email, idx) => (
                            <li key={idx}>{email}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {result.results.errors.length > 0 && (
                      <div className="details error">
                        <h5>❌ Erreurs :</h5>
                        <ul>
                          {result.results.errors.map((item, idx) => (
                            <li key={idx}>
                              {item.email} : {item.error}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="error-message">
                    <span className="icon">❌</span>
                    <h4>Erreur lors de la génération</h4>
                    <p>{result.error}</p>
                  </div>
                )}
              </div>
            )}

            <button 
              className="close-btn"
              onClick={() => setShowModal(false)}
              disabled={isGenerating}
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default GenerateMonthlyButton;